<app-catalog-item #item [data]="_item" [mode]="FormMode.Edit"></app-catalog-item>

<div
  [hidden]="itemId && itemId != ''"
  style="color: #444444; word-wrap: break-word"
>
  Any changes you make to an item will not be reflected on any existing invoices
  that already include the item.
</div>

<div style="display: flex; align-items: start; gap: 20px; margin: 20px auto; justify-content: center;">
  <input
    type="button"
    value="Cancel"
    class="cancel"
    (click)="btnCancel_click()"
    (keydown.escape)="btnCancel_click()"
  />

  <input *ngIf="{ disabled: !item.itemValid || !item.itemChanged } as vars"
    type="button"\ [value]="isNew ? 'Save' : 'Update'" class="primary" 
    [disabled]="vars.disabled" 
    (click)="vars.disabled ? null : btnSave_click()" 
    (keydown.enter)="vars.disabled ? null : btnSave_click()"
  />
</div>
